/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import './stickany';
import 'offside-js/dist/offside.css';
import offside from 'offside-js';

$(document).ready(() => {
  //Offside.js minimal setup
  var myOffside = offside( '#cr-menu', {
    slidingElementsSelector:'.wrapper',
    buttonsSelector: '#open',
    slidingSide: 'right',
    closeOpenOffside: ''
  });

  $('.navTrigger').click(function(){
    $(this).toggleClass('active');
    $(this).css('right', '5px');
    $(this).appendTo('.nav-primary');
    $(this).css('margin','auto');

    if($(this).hasClass('active')) {
      $(this).css('margin','20px');
      $(this).css('right', $("#cr-menu").width() - 10);
      $(this).appendTo('body');
    }
  });

  $(".close-menu").on('click', function() {
    myOffside.close();
  })

  $(document).scroll(function() {
    var y = $(document).scrollTop(), //get page y value
      header = $(".banner"); // your div id
    if(y >= 60)  {
      header.addClass('sticked');
    } else {
      header.removeClass("sticked");
    }
  });
});
